import {createSelector} from 'reselect';
import {getSelectedMembership} from '../../App/selectors';

export const selectSelectedMembershipId = createSelector([getSelectedMembership], memberships => memberships);
